import React from "react";
import "./SagwanWoodAbout.css";
import SagwanWoodLogo from "../../../assets/Sagwan Wood.png";

function SagwanWoodAbout() {
  return (
    <div className="Sagwan-Wood-About-Page-1-container">
      <div className="Sagwan-Wood-About-Page-1-content">
        <div className="Sagwan-Wood-About-Page-1-text-container">
          <h1 className="Sagwan-Wood-About-Page-1-main-title">
            SagwanWood.com
          </h1>
          <p className="Sagwan-Wood-About-Page-1-descriptions">
            SagwanWood.com goes beyond woodworking; it encapsulates a symphony
            that harmonizes artistry and craftsmanship. Envision a digital
            atelier where wood transforms into functional elegance.
            <br />
            <br />
            Our platform isn't a mere repository; it's an artisanal cosmos where
            designs transmute into life.
            <br />
            <br />
            Craft bespoke furniture, conceive exquisite interiors, and shape
            spaces resonating with timeless grandeur.
            <br />
            <br />
            SagwanWood.com isn't a mere marketplace; it stands as a tribute to
            the art of creation, where each product emerges as a masterpiece
            steeped in trust and quality.
          </p>
        </div>
        <div className="Sagwan-Wood-About-Page-1-logo-container">
          <a
            href="http://sagwanwood.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={SagwanWoodLogo}
              alt="SagwanWood Logo"
              className="Sagwan-Wood-About-Page-1-logo"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default SagwanWoodAbout;
